import { Button } from 'native-base';

// Props
type Props = {
  onPress?: any;
  text: string;

  // Properties
  disabled?: boolean;
  isLoading?: boolean;

  // Icons
  startIcon?: any;
  endIcon?: any;

  // Styling (quick)
  bg?: string;
  color?: string;
  fontSize?: number;
  fontWeight?: number;
  size?: number | string;
  width?: number | string;
  px?: number | string;
  py?: number | string;
  style?: object; // Styling (full)
};

export const PrimaryButton = ({
  onPress = undefined,
  text,

  disabled = false,
  isLoading = false,

  startIcon = undefined,
  endIcon = undefined,

  bg = 'primary.400',
  color = 'black',
  fontSize = 16,
  fontWeight = 600,
  px = 5,
  py = 3,
  size = 'md',
  width,
  style = undefined,
}: Props) => {
  return (
    <Button
      onPress={onPress}
      _pressed={{ backgroundColor: 'primary.300' }}
      disabled={disabled}
      isLoading={isLoading}
      startIcon={startIcon}
      endIcon={endIcon}
      px={px}
      py={py}
      size={size}
      width={width}
      bg={disabled ? 'surface.300' : bg}
      opacity={disabled ? 0.4 : 0.75}
      rounded={'full'}
      _hover={{
        opacity: 1,
        backgroundColor: bg,
      }}
      _text={{
        textAlign: 'center',
        color: disabled ? 'surface.500' : color,
        fontSize: fontSize,
        fontFamily: 'body',
        fontWeight: fontWeight,
        fontStyle: 'normal',
      }}
      style={{ ...style }}
    >
      {text}
    </Button>
  );
};
